/* @flow strict */

import * as React from "react";
import DropCropeZone from "/client/src/pages/Events/detail/selfCheckinRoot/DropCropeZone";
import {
  CTooltip,
  CTooltipLabel,
  CTooltipText
} from "/client/src/components/tooltip/";

type PropsType = {
  openedCropModal: any,
  baseImage: any,
  croppedImage: any,
  imgUrl: any,
  handleSetImages: () => void,
  setOpenedCropModal: () => void,
  setBaseImage: () => void,
  setCroppedImage: () => void,
  setImageCropInfo: (info: any) => void,
  image_crop_info: any
};

const EventPicture = ({
  openedCropModal,
  baseImage,
  croppedImage,
  handleSetImages,
  setOpenedCropModal,
  setBaseImage,
  setCroppedImage,
  setImageCropInfo,
  image_crop_info,
  imgUrl
}: PropsType): React.Element<"div"> => {
  return (
    <div className="form-group EventPicture">
      <label>
        Event Picture
        <CTooltip>
          <CTooltipLabel standart>?</CTooltipLabel>
          <CTooltipText>Image dimension 1045 x 415</CTooltipText>
        </CTooltip>
      </label>
      <div className="dropzone dropzone-single">
        <DropCropeZone
          openedCropModal={openedCropModal}
          baseImage={baseImage}
          croppedImage={croppedImage}
          setOpenedCropModal={setOpenedCropModal}
          setBaseImage={setBaseImage}
          setCroppedImage={setCroppedImage}
          id="coverImg"
          handleSetImages={handleSetImages}
          setImageCropInfo={setImageCropInfo}
          image_crop_info={image_crop_info}
          imgUrl={imgUrl}
          imageSizeLimit={10}
        />
      </div>
      {baseImage.image ? (
        <div
          className="form-group form-group--adjust"
          style={{
            marginTop: "1rem"
          }}
        >
          <button
            type="button"
            className="btn btn-default-blue"
            onClick={() => {
              setOpenedCropModal(true);
            }}
          >
            <i className="icon icon-crop" style={{ marginRight: "1rem" }} />
            <span>Adjust</span>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default EventPicture;
